import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../../../AccountForm.meta';
import { Toggle } from '../../../../../../../../../../CommonComponents/OPL/Toggle/Toggle';

export const SyncAssetAllocationToggle = () => {
  const formBag = useFormContext<FormFields>();

  const showAccount = formBag.watch('bankAccount.ShowAccount');

  return (
    <Toggle
      {...formBag.register('bankAccount.SyncAssetAllocationEnabled')}
      size="small"
      disabled={!showAccount}
    >
      Sync Asset Allocation
    </Toggle>
  );
};
